<template>
  <div class="demo_wrap">
    <div class="demo_title_wrap">
      <h1>{{ demoInfo.title }}</h1>
      <p>
        {{ demoInfo.subtitle }}
      </p>
    </div>
    <div class="demo_form hidden-xs-only">
      <Form :model="formTop" label-position="top" inline class="demo_form_item1">
        <FormItem label="想了解的产品服务" style="width: 46%" class="form_item1" required>
          <Select v-model="formTop.service" placeholder="请选择" size="large">
            <Option :value="item.value" v-for="item in selectData">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="姓名" style="width: 46%" class="form_item1" required>
          <Input v-model="formTop.input" placeholder="请输入您的姓名" size="large"></Input>
        </FormItem>
      </Form>
      <Form :model="formTop2" label-position="top" inline class="demo_form_item2">
        <FormItem label="手机号" style="width: 23%" class="form_item2" required>
          <Input v-model="formTop2.phone" placeholder="请输入您的手机号" size="large"></Input>
        </FormItem>
        <FormItem label="" style="width: 22%" class="form_item2" required>
          <!-- <Input v-model="formTop2.code" placeholder="请输入您的验证码" search enter-button="获取验证码" size="large"></Input> -->
        </FormItem>
        <FormItem label="邮箱" style="width: 46%" class="form_item2" required>
          <Input v-model="formTop2.email" placeholder="请输入您的邮箱" size="large"></Input>
        </FormItem>
      </Form>
      <Form :model="formTop3" label-position="top" inline class="demo_form_item2">
        <FormItem label="政府/园区/机构/企业名称" style="width: 46%" class="form_item3" required>
          <Input v-model="formTop3.gongsi" placeholder="请输入您的公司名称" size="large"></Input>
        </FormItem>
        <FormItem label="您的职务" style="width: 46%" class="form_item3">
          <Input v-model="formTop3.zhiwu" placeholder="请输入您的职务" size="large"></Input>
        </FormItem>
        <FormItem label="备注" style="width: 92%" class="form_item3">
          <Input v-model="formTop3.beizhu" placeholder="您的大概需求" type="textarea" :rows="5" maxlength="200"></Input>
        </FormItem>
      </Form>
      <div class="form_bottom">
        <el-checkbox v-model="accept">点击提交视为您已阅读并同意
          <el-popover placement="top" width="350" trigger="hover" :content="privacyPolicy"
            popper-class="privacy-popover">
            <span slot="reference"
              style="color: #409EFF; text-decoration: underline; cursor: pointer;font-size: 12PX;">《隐私政策》</span>
          </el-popover>
        </el-checkbox>
        <el-button class="btn" @click="onSubmit">点击预约</el-button>
      </div>
    </div>

    <div class="demo_form_mobile hidden-sm-and-up">
      <Form :model="formTopMobile" label-position="top" class="demo_form_item1">
        <FormItem label="想了解的产品服务" class="form_item1" required>
          <!-- <Cascader
            :data="selectData"
            v-model="formTopMobile.service"
          ></Cascader> -->
          <el-select v-model="formTopMobile.service" placeholder="请选择活动区域">
            <el-option :label="item.label" :value="item.value" v-for="(item, index) in selectData"
              :key="index"></el-option>
          </el-select>
        </FormItem>
        <FormItem label="姓名" class="form_item1" required>
          <Input v-model="formTopMobile.input" placeholder="请输入您的姓名" size="large"></Input>
        </FormItem>
        <FormItem label="手机号" class="form_item2" required>
          <Input v-model="formTopMobile.phone" placeholder="请输入您的手机号" size="large"></Input>
        </FormItem>
        <FormItem label="邮箱" class="form_item2" required>
          <Input v-model="formTopMobile.email" placeholder="请输入您的邮箱" size="large"></Input>
        </FormItem>
        <FormItem label="政府/园区/机构/企业名称" class="form_item3" required>
          <Input v-model="formTopMobile.gongsi" placeholder="请输入您的公司名称" size="large"></Input>
        </FormItem>
        <FormItem label="您的职务" class="form_item3">
          <Input v-model="formTopMobile.zhiwu" placeholder="请输入您的职务" size="large"></Input>
        </FormItem>
        <FormItem label="备注" class="form_item3">
          <Input v-model="formTopMobile.beizhu" placeholder="您的大概需求" type="textarea" :rows="15" maxlength="200"></Input>
        </FormItem>
      </Form>
      <div class="form_bottom">
        <div class="bottom_top">
          <input type="checkbox" id="checkmy" v-model="acceptMobile" />
          <label for="checkmy" style="font-size: 12px;padding-left:8px;">
            点击提交视为您已阅读并同意
            <el-popover placement="top" width="350" trigger="hover" :content="privacyPolicy"
              popper-class="privacy-popover">
              <span slot="reference" style="color: #409EFF; text-decoration: underline; cursor: pointer;">《隐私政策》</span>
            </el-popover>
          </label>
        </div>
        <el-button class="btn" @click="onSubmit">点击预约</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { addSubscribe, leftLikeDict } from '../../api/system';
import { findMainProp } from '../../utils';

export default {
  data() {
    return {
      prodThree1: {},
      formTop: {
        input: '',
        service: '',
      },
      formTop2: {
        email: '',
        code: '',
        phone: '',
      },
      formTop3: {
        gongsi: '',
        zhiwu: '',
        beizhu: '',
      },
      formTopMobile: {
        input: '',
        service: [],
        email: '',
        code: '',
        phone: '',
        gongsi: '',
        zhiwu: '',
        beizhu: '',
      },
      accept: false,
      acceptMobile: false,
      demoInfo: {},
      privacyPolicy: ''
    }
  },
  methods: {
    onSubmit() {
      // 判断是移动端还是PC端
      const isMobile = window.innerWidth <= 768
      const acceptValue = isMobile ? this.acceptMobile : this.accept

      // 验证是否同意隐私协议
      if (!acceptValue) {
        this.$alert('请先阅读并同意《隐私政策》', '提示', {
          confirmButtonText: '确定'
        });
        return
      }

      // 获取表单数据
      const formData = isMobile
        ? {
          service: this.formTopMobile.service,
          input: this.formTopMobile.input,
          phone: this.formTopMobile.phone,
          email: this.formTopMobile.email,
          gongsi: this.formTopMobile.gongsi,
          zhiwu: this.formTopMobile.zhiwu,
          beizhu: this.formTopMobile.beizhu,
        }
        : {
          service: this.formTop.service,
          input: this.formTop.input,
          phone: this.formTop2.phone,
          email: this.formTop2.email,
          gongsi: this.formTop3.gongsi,
          zhiwu: this.formTop3.zhiwu,
          beizhu: this.formTop3.beizhu,
        }

      // 基本验证
      if (!formData.service || !formData.input || !formData.phone || !formData.email || !formData.gongsi) {
        this.$message({
          message: '请填写所有必填项',
          type: 'warning'
        })
        return
      }

      addSubscribe(formData).then(res => {
        this.$message({
          message: '预约成功!我们会在1个工作日内与您联系',
          type: 'success'
        })
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
        .catch(() => {
          this.$message({
            message: '预约失败!请重试',
            type: 'error'
          })
        })


    },
    async leftLikeDictFunc() {
      const res = await leftLikeDict('demo');
      if (res.data) {
        this.demoInfo = findMainProp(res.data.data, 'demo')
      }
      const res2 = await leftLikeDict('privacy_policy');
      if (res2.data) {
        this.privacyPolicy = res2.data.data[0]?.dictValue || ''
      }
    }
  },
  computed: {
    ...mapGetters(['getMenuList']),
    selectData() {
      return this.getMenuList.find(v => v.routePath === '/production')?.children.map(v => {
        return {
          label: v.menuName,
          value: v.menuName
        }
      })
    },
  },
  mounted() {
    this.leftLikeDictFunc()
  }
}
</script>

<style lang="scss">
.privacy-popover {
  font-size: 12PX;
}

.demo_wrap {
  padding-top: 150px;

  @media screen and (max-width: 768px) {
    padding: 20px;
  }

  .demo_title_wrap {
    text-align: center;

    @media screen and (max-width: 768px) {
      text-align: left;
    }

    h1 {
      font-size: 32px;

      @media screen and (max-width: 768px) {
        font-size: 28px;
      }
    }

    p {
      font-size: 18px;
      margin-top: 10px;

      @media screen and (max-width: 768px) {
        font-size: 16px;
        margin-top: 10px;
      }
    }
  }

  .demo_form {
    width: 70%;
    margin: 0 auto;

    @media screen and (max-width: 768px) {
      font-size: 16px;
      margin-top: 10px;
    }

    .demo_form_item1 {
      margin-top: 40px;

      .form_item1 {}
    }

    .form_bottom {
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 80px;

      .btn {
        background: orange;
        color: #fff;
        border-radius: 20px;
        position: absolute;
        left: 46%;
        transform: translateX(-46%);
      }
    }
  }

  .demo_form_mobile {
    margin-top: 1rem;

    .demo_form_item1 {
      width: 100%;

      .form_item1 {
        margin-top: 1rem;

        ::placeholder {
          font-size: 14PX;
        }
      }

      .form_item2 {
        margin-top: 1rem;

        ::placeholder {
          font-size: 14PX;
        }
      }

      .form_item3 {
        margin-top: 1rem;

        ::placeholder {
          font-size: 14PX;
        }
      }
    }

    .form_bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;

      .bottom_top {
        color: #999;
        margin-top: 10PX;
      }

      .btn {
        background: orange;
        color: #fff;
        border-radius: 20PX;
        width: 80PX;
        height: 30PX;
        margin-top: 20PX;

        @media screen and (max-width: 768px) {
          width: 90px;
          height: 30px;
          font-size: 16px;
        }

      }
    }
  }
}

@media screen and (max-width: 768px) {

  .ivu-input,
  .ivu-input-group-prepend {
    height: 40PX !important;
    font-size: 1rem;
  }

  .ivu-form-item-label {
    font-size: 1rem !important;
  }

  .ivu-input-large {
    font-size: 1rem !important;
  }

  .ivu-cascader-menu .ivu-input-search {
    font-size: 1rem !important;
  }

  .ivu-input-group-large>.ivu-input-group-append {
    font-size: 14PX !important;
    padding: 0 10PX !important;
  }

  // .ivu-select-dropdown{
  //   transform: scale(4);
  //   left: 38% !important;
  // }
  .el-input {
    font-size: 1rem !important;

    input {
      height: 40PX;
    }

    span {
      transform: translateY(-40%);
    }
  }

  .el-select {
    width: 100%;
  }

  .el-select-dropdown__item {
    font-size: 14PX;
    padding: 15PX 0;
  }
}
</style>